import React, { useContext, useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import { UserContext } from "./UserContext"
import { axiosAuth_IDENT_MGMT_API } from "./utils/AxoisUtilComponent"
//import { axiosAuth_DATA_MGMT_API } from "./utils/AxoisUtilComponent"
import { useRefreshTokenListener } from "./utils/refreshTokenEvent"
import { usePageIdle } from './utils/pageIdle'

const ProtectedRoute = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  useRefreshTokenListener()

  const { setUser } = useContext(UserContext)

  const accessToken = sessionStorage.getItem("accessToken")

  usePageIdle()

  useEffect(() => {

    fetchUserInfo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchUserInfo = async () => {

    try {

      const res = await axiosAuth_IDENT_MGMT_API.get("curr-user-info/")

      if (res.status === 200) {

        let tmpUserInfo = res.data;

/* ##### For future enhancement to support showing notifications for the user #####
        const res2 = await axiosAuth_DATA_MGMT_API.get("notifs/users/" + tmpUserInfo.userId + "?status=NTF_ST_NEW" +
                                                       "&limit=1&offset=0");

        if (res2.status === 200) {
          tmpUserInfo.notifCount = res2.data.total;
        }
*/

        setUser({
          isAuth: true,
          userInfo: tmpUserInfo,
        });

        setIsLoggedIn(true);
      }

    } catch (error) {
      return null
    }
  }

  if (!accessToken) {
    return <Navigate to="/Login/en" replace />
  }

  if (!isLoggedIn) {
    return null
  }

  return children
}


export default ProtectedRoute
